export default __webpack_public_path__ + "static/media/red-uld-pin.64d118c2.svg";